import fetch from '@/plugin/axios'

// 获取场景列表
export function getBotSceneList (data) {
  return fetch({
    url: '/api/order/bot-scene/list',
    method: 'Post',
    data: data
  })
}

// 新增场景
export function addBotScene (data) {
  return fetch({
    url: '/api/order/bot-scene/add',
    method: 'Post',
    data: data
  })
}

// 修改场景
export function updateBotScene (id, data) {
  return fetch({
    url: `/api/order/bot-scene/update/${id}`,
    method: 'Post',
    data: data
  })
}

// 删除场景
export function deleteBotScene (id) {
  return fetch({
    url: `/api/order/bot-scene/${id}`,
    method: 'Delete'
  })
}

// 获取时机状态列表
export function getBotSceneStates () {
  return fetch({
    url: '/api/order/bot-scene/states',
    method: 'Get'
  })
}
